module.exports = __webpack_public_path__ + "img/mike-erskine-S_VbdMTsdiA-unsplash.a90d24a8.jpg";